import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Drawer } from "antd";
import { FiMenu, FiX, FiChevronDown, FiChevronUp } from "react-icons/fi";
import "../../styles/Navbar.css";
import logo from "../../assets/images/logo1.png";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isPropertyDropdownOpen, setIsPropertyDropdownOpen] = useState(false);
  const [isMobileToolsOpen, setIsMobileToolsOpen] = useState(false);
  const [isMobilePropertiesOpen, setIsMobilePropertiesOpen] = useState(false);

  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    // Reset all dropdowns when closing
    if (isOpen) {
      setIsDropdownOpen(false);
      setIsPropertyDropdownOpen(false);
      setIsMobileToolsOpen(false);
      setIsMobilePropertiesOpen(false);
    }
  };

  const closeMenu = () => {
    setIsOpen(false);
    setIsDropdownOpen(false);
    setIsPropertyDropdownOpen(false);
    setIsMobileToolsOpen(false);
    setIsMobilePropertiesOpen(false);
  };

  const toggleMobileTools = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMobileToolsOpen(!isMobileToolsOpen);
  };

  const toggleMobileProperties = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMobilePropertiesOpen(!isMobilePropertiesOpen);
  };

  const isActive = (path) => location.pathname === path;

  const handlePropertyMouseEnter = () => {
    setIsPropertyDropdownOpen(true);
  };

  const handlePropertyMouseLeave = () => {
    setIsPropertyDropdownOpen(false);
  };

  const handleToolsMouseEnter = () => {
    setIsDropdownOpen(true);
  };

  const handleToolsMouseLeave = () => {
    setIsDropdownOpen(false);
  };

  return (
    <nav className="siteNav">
      <div className="navbar-gold-bar"></div>
      <div className="container">
        <div className="menuBgWrap">
          <div className="site-navigation">
            <Link to="/" onClick={closeMenu}>
              <img className="logo" src={logo} alt="Sharambea Properties" />
            </Link>

            {/* Desktop Menu */}
            <ul className="siteMenu">
              <li className="siteMenuItem">
                <Link
                  to="/"
                  className={`siteMenuLink ${isActive("/") ? "active" : ""}`}
                  onClick={closeMenu}
                >
                  Home
                </Link>
              </li>

              <li
                className="siteMenuItem has-dropdown"
                onMouseEnter={handlePropertyMouseEnter}
                onMouseLeave={handlePropertyMouseLeave}
              >
                <span className="siteMenuLink" style={{ cursor: "pointer" }}>
                  Properties
                  <FiChevronDown className="dropdown-icon" />
                </span>
                <ul
                  className={`dropdownMenu ${
                    isPropertyDropdownOpen ? "open" : ""
                  }`}
                >
                  <li>
                    <Link
                      to="/properties?property_type=sale"
                      className={`dropdownItem ${
                        isActive("/properties?property_type=sale")
                          ? "active"
                          : ""
                      }`}
                      onClick={closeMenu}
                    >
                      For Sale
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/properties?property_type=rent"
                      className={`dropdownItem ${
                        isActive("/properties?property_type=rent")
                          ? "active"
                          : ""
                      }`}
                      onClick={closeMenu}
                    >
                      For Rent
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="siteMenuItem">
                <Link
                  to="/services"
                  className={`siteMenuLink ${
                    isActive("/services") ? "active" : ""
                  }`}
                  onClick={closeMenu}
                >
                  Services
                </Link>
              </li>

              <li className="siteMenuItem">
                <Link
                  to="/about"
                  className={`siteMenuLink ${
                    isActive("/about") ? "active" : ""
                  }`}
                  onClick={closeMenu}
                >
                  About
                </Link>
              </li>

              <li
                className="siteMenuItem has-dropdown"
                onMouseEnter={handleToolsMouseEnter}
                onMouseLeave={handleToolsMouseLeave}
              >
                <span className="siteMenuLink" style={{ cursor: "pointer" }}>
                  Tools
                  <FiChevronDown className="dropdown-icon" />
                </span>
                <ul className={`dropdownMenu ${isDropdownOpen ? "open" : ""}`}>
                  <li>
                    <Link
                      to="/bond-repayment-calculator"
                      className={`dropdownItem ${
                        isActive("/bond-repayment-calculator") ? "active" : ""
                      }`}
                      onClick={closeMenu}
                    >
                      Bond Repayment Calculator
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/affordability-calculator"
                      className={`dropdownItem ${
                        isActive("/affordability-calculator") ? "active" : ""
                      }`}
                      onClick={closeMenu}
                    >
                      Affordability Calculator
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/list-your-property"
                      className={`dropdownItem ${
                        isActive("/list-your-property") ? "active" : ""
                      }`}
                      onClick={closeMenu}
                    >
                      List/Request Property
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/market-estimate"
                      className={`dropdownItem ${
                        isActive("/market-estimate") ? "active" : ""
                      }`}
                      onClick={closeMenu}
                    >
                      Market Estimate
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="siteMenuItem">
                <Link
                  to="/contact"
                  className={`siteMenuLink ${
                    isActive("/contact") ? "active" : ""
                  }`}
                  onClick={closeMenu}
                >
                  Contact Us
                </Link>
              </li>
            </ul>

            {/* Mobile Drawer */}
            <Drawer
              placement="right"
              onClose={closeMenu}
              open={isOpen}
              width={300}
              className="DrawerMenu"
            >
              <ul className="drawerMenu">
                <li className="drawerMenuItem">
                  <Link
                    to="/"
                    className={`drawerMenuLink ${
                      isActive("/") ? "active" : ""
                    }`}
                    onClick={closeMenu}
                  >
                    Home
                  </Link>
                </li>

                <li className="drawerMenuItem">
                  <div
                    className="drawerMenuLink dropdown-trigger"
                    onClick={toggleMobileProperties}
                  >
                    <span>Properties</span>
                    {isMobilePropertiesOpen ? (
                      <FiChevronUp className="dropdown-chevron" />
                    ) : (
                      <FiChevronDown className="dropdown-chevron" />
                    )}
                  </div>
                  <ul
                    className={`drawerDropdownMenu ${
                      isMobilePropertiesOpen ? "open" : ""
                    }`}
                  >
                    <li>
                      <Link
                        to="/properties?property_type=sale"
                        className={`dropdownItem ${
                          isActive("/properties?property_type=sale")
                            ? "active"
                            : ""
                        }`}
                        onClick={closeMenu}
                      >
                        For Sale
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/properties?property_type=rent"
                        className={`dropdownItem ${
                          isActive("/properties?property_type=rent")
                            ? "active"
                            : ""
                        }`}
                        onClick={closeMenu}
                      >
                        For Rent
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="drawerMenuItem">
                  <Link
                    to="/services"
                    className={`drawerMenuLink ${
                      isActive("/services") ? "active" : ""
                    }`}
                    onClick={closeMenu}
                  >
                    Services
                  </Link>
                </li>

                <li className="drawerMenuItem">
                  <Link
                    to="/about"
                    className={`drawerMenuLink ${
                      isActive("/about") ? "active" : ""
                    }`}
                    onClick={closeMenu}
                  >
                    About
                  </Link>
                </li>

                <li className="drawerMenuItem">
                  <div
                    className="drawerMenuLink dropdown-trigger"
                    onClick={toggleMobileTools}
                  >
                    <span>Tools</span>
                    {isMobileToolsOpen ? (
                      <FiChevronUp className="dropdown-chevron" />
                    ) : (
                      <FiChevronDown className="dropdown-chevron" />
                    )}
                  </div>
                  <ul
                    className={`drawerDropdownMenu ${
                      isMobileToolsOpen ? "open" : ""
                    }`}
                  >
                    <li>
                      <Link
                        to="/bond-repayment-calculator"
                        className={`dropdownItem ${
                          isActive("/bond-repayment-calculator") ? "active" : ""
                        }`}
                        onClick={closeMenu}
                      >
                        Bond Repayment Calculator
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/affordability-calculator"
                        className={`dropdownItem ${
                          isActive("/affordability-calculator") ? "active" : ""
                        }`}
                        onClick={closeMenu}
                      >
                        Affordability Calculator
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/list-your-property"
                        className={`dropdownItem ${
                          isActive("/list-your-property") ? "active" : ""
                        }`}
                        onClick={closeMenu}
                      >
                        List/Request Property
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/market-estimate"
                        className={`dropdownItem ${
                          isActive("/market-estimate") ? "active" : ""
                        }`}
                        onClick={closeMenu}
                      >
                        Market Estimate
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="drawerMenuItem">
                  <Link
                    to="/contact"
                    className={`drawerMenuLink ${
                      isActive("/contact") ? "active" : ""
                    }`}
                    onClick={closeMenu}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </Drawer>

            {/* Burger Icon for Menu Toggle */}
            <div className="burger" onClick={toggleMenu}>
              {isOpen ? <FiX /> : <FiMenu />}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
